/**
 * 18+ yaş onayı kapısı (7593 sayılı Kanun — kesici/delici aletlerin 18 yaş altına satış yasağı).
 *
 * Sepet formundaki "Ödemeye Geç" butonu, yaş onayı kutucuğu işaretlenmeden çalışmaz.
 * #cart-footer sepet güncellemelerinde innerHTML olarak yeniden yazıldığı için:
 *   - dinleyiciler document seviyesinde delege edilir (yeniden bağlanmaya gerek kalmaz),
 *   - onay durumu sessionStorage'da tutulur ve her yeniden çizimde geri yüklenir.
 */
(function () {
  var STORAGE_KEY = 'andac:age-confirmed';
  var GATE = '[data-age-gate]';
  var BOX = '[data-age-gate-checkbox]';
  var ERROR = '[data-age-gate-error]';
  var CHECKOUT = '[name="checkout"]';
  var DYNAMIC = '.cart__dynamic-checkout-buttons';

  function isConfirmed() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setConfirmed(value) {
    try {
      if (value) sessionStorage.setItem(STORAGE_KEY, '1');
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* private mode: durum sadece bu sayfa için geçerli olur */
    }
  }

  // Kutucuk ile butonların eşleştiği kapsam (sepet formu, sepet bildirimi vb.).
  function scopeOf(element) {
    return (
      element.closest('[data-age-gate-scope]') ||
      element.closest('form') ||
      element.closest('.cart-footer') ||
      document
    );
  }

  function toggleError(gate, show) {
    var message = gate.querySelector(ERROR);
    if (message) message.hidden = !show;
    gate.classList.toggle('age-gate--invalid', show);
  }

  // Tüm sepetlerdeki (sayfa + drawer) kutucuk ve buton durumunu tek doğruya göre günceller.
  function sync() {
    var confirmed = isConfirmed();

    Array.prototype.forEach.call(document.querySelectorAll(GATE), function (gate) {
      var box = gate.querySelector(BOX);
      if (box && box.checked !== confirmed) box.checked = confirmed;
      if (confirmed) toggleError(gate, false);

      var scope = scopeOf(gate);

      Array.prototype.forEach.call(scope.querySelectorAll(CHECKOUT), function (button) {
        button.classList.toggle('age-gate-locked', !confirmed);
        button.setAttribute('aria-disabled', confirmed ? 'false' : 'true');
      });

      // Shop Pay / hızlandırılmış ödeme butonları da aynı şarta bağlanır.
      Array.prototype.forEach.call(scope.querySelectorAll(DYNAMIC), function (wrapper) {
        wrapper.classList.toggle('age-gate-blocked', !confirmed);
      });
    });
  }

  function blockAndWarn(event, gate) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    if (!gate) return;
    toggleError(gate, true);

    var box = gate.querySelector(BOX);
    if (box) {
      if (typeof gate.scrollIntoView === 'function') {
        gate.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      box.focus({ preventScroll: true });
    }
  }

  function gateFor(element) {
    var scope = scopeOf(element);
    return (scope.querySelector ? scope.querySelector(GATE) : null) || document.querySelector(GATE);
  }

  document.addEventListener('change', function (event) {
    var box = event.target.closest ? event.target.closest(BOX) : null;
    if (!box) return;
    setConfirmed(box.checked);
    sync();
  });

  // Ödeme butonuna (ve hızlandırılmış ödeme alanına) tıklama: onay yoksa engelle.
  document.addEventListener(
    'click',
    function (event) {
      if (isConfirmed() || !event.target.closest) return;

      var trigger = event.target.closest(CHECKOUT) || event.target.closest('.age-gate-blocked');
      if (!trigger) return;
      if (!scopeOf(trigger).querySelector || !scopeOf(trigger).querySelector(GATE)) return;

      blockAndWarn(event, gateFor(trigger));
    },
    true
  );

  // Klavye ile submit dahil, formun kendisi de korunur.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.querySelector || !form.querySelector(GATE)) return;
      if (isConfirmed()) return;
      blockAndWarn(event, form.querySelector(GATE));
    },
    true
  );

  document.addEventListener('cart:update', function () {
    setTimeout(sync, 0);
  });

  // Sepet AJAX ile yeniden çizildiğinde durumu geri yükle.
  if (typeof MutationObserver === 'function') {
    var scheduled = false;
    new MutationObserver(function (mutations) {
      if (scheduled) return;

      var touchesGate = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches(GATE) || node.querySelector(GATE));
        });
      });
      if (!touchesGate) return;

      scheduled = true;
      // rAF değil: sekme arka plandayken rAF durur, sepet durumu geri yüklenmezdi.
      setTimeout(function () {
        scheduled = false;
        sync();
      }, 0);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
